// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_mvADE","col_navlist":"index_col_navlist_gKU7f","pa":"index_pa_99H0R"};